// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-tDIU","title":"styles_title__XajZB"};